define("powergen/routes/application",
  [],
  function() {
    "use strict";
    var ApplicationRoute;

    ApplicationRoute = Ember.Route.extend({
      model: function() {
        return this.get('store').find('game', 'main');
      },
      setupController: function(controller, model) {
        controller.set('model', model);
        if (!this.get('manager')["static"]) {
          return controller.startTimer();
        }
      }
    });


    return ApplicationRoute;
  });